import React from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import {
  setMenuVisible,
  setQuestionModalVisible,
  setTextModalVisible,
  setAssignSectionModalVisible,
  setUpdateMeetingTitleModalVisible,
  setEditingQuestionContext,
  setEditingTextContext,
  setFetchedQuestionData,
} from '../../store/slices/editorUISlice';
import MenuItem from '../../../../components/CreateMeetingFooter/SectionMenu/Menu/MenuItem';
import menuItemClasses from '../../../../components/CreateMeetingFooter/SectionMenu/Menu/MenuItem/styles.module.scss';
import menuClasses from '../../../../components/CreateMeetingFooter/SectionMenu/Menu/styles.module.scss';
import videoIcon from '../../../../assets/images/section-menu/video.png';
import selfIcon from '../../../../assets/images/section-menu/self.svg';
import desktopIcon from '../../../../assets/images/section-menu/desktop.svg';
import audioIcon from '../../../../assets/images/section-menu/audio.svg';
import questionIcon from '../../../../assets/images/section-menu/question.svg';
import assignIcon from '../../../../assets/images/section-menu/section.png';
import notesIcon from '../../../../assets/images/section-menu/notes.svg';
import importIcon from '../../../../assets/images/section-menu/import.svg';
import imageIcon from '../../../../assets/images/section-menu/image.png';
import documentIcon from '../../../../assets/images/section-menu/document.png';

export default function AddSectionMenu({
  isMenuVisible,
  menuPosition,
  menuRef,
  isEditMode,
  meetingTitle,
  handleRecordSelf,
  handleRecordAudio,
  setIsScreenRecordReminderVisible,
  setIsImportFileChoiceVisible,
  setIsUploadImagesModalVisible,
  setIsUploadDocumentsModalVisible,
  isMobile = false,
  isCreator = true, // Default to true for backward compatibility
  isContributorClosed = false,
}) {
  const dispatch = useDispatch();

  if (!isMenuVisible || isContributorClosed) return null; // Don't show menu for contributor-closed users

  const recordSubMenu = [
    {
      label: 'Record self',
      icon: selfIcon,
      disabled: false,
      forceEnable: true,
      onClick: handleRecordSelf,
    },
    ...(!isMobile
      ? [{
          label: 'Record screen',
          icon: desktopIcon,
          disabled: false,
          forceEnable: true,
          onClick: () => {
            dispatch(setMenuVisible(false));
            setIsScreenRecordReminderVisible(true);
          },
        }]
      : []),
    {
      label: 'Record audio',
      icon: audioIcon,
      disabled: false,
      forceEnable: true,
      onClick: handleRecordAudio,
    },
  ];

  return createPortal(
    <div
      ref={menuRef}
      className={menuClasses.menu}
      style={{
        left: menuPosition.left,
        bottom: menuPosition.bottom,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <ul>
        {/* Record options - submenu */}
        <MenuItem
          disabled={false}
          icon={videoIcon}
          label="Record options"
          subMenu={recordSubMenu}
          menuRef={menuRef}
          leftPosition={menuPosition.left}
          isMenuVisible={isMenuVisible}
        />
        {/* Add a question */}
        <MenuItem
          disabled={false}
          icon={questionIcon}
          label="Add a question"
          onClick={() => {
            dispatch(setMenuVisible(false));
            dispatch(setEditingQuestionContext(null));
            dispatch(setFetchedQuestionData(null));
            dispatch(setQuestionModalVisible(true));
          }}
          menuRef={menuRef}
          leftPosition={menuPosition.left}
          isMenuVisible={isMenuVisible}
        />
        {/* Assign a section - only for creators */}
        {isCreator && (
          /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
        <li
          className={`${menuItemClasses.MenuItem} ${!isEditMode ? menuItemClasses.disabled : ''}`}
          title={!isEditMode ? 'You have to first save video to assign a section' : ''}
          onClick={() => {
            if (!isEditMode) return;
            dispatch(setMenuVisible(false));
            dispatch(setAssignSectionModalVisible(true));
          }}
        >
          <span>
            <img src={assignIcon} alt="Assign a section" />
          </span>
          <div className={menuItemClasses.nameContainer}>
            Assign a section
          </div>
        </li>
        )}
        {/* Add text */}
        <MenuItem
          disabled={false}
          icon={notesIcon}
          label="Add text"
          onClick={() => {
            dispatch(setMenuVisible(false));
            dispatch(setEditingTextContext(null));
            dispatch(setTextModalVisible(true));
          }}
          menuRef={menuRef}
          leftPosition={menuPosition.left}
          isMenuVisible={isMenuVisible}
        />
        {/* Import file */}
        <MenuItem
          disabled={false}
          icon={importIcon}
          label="Import video"
          onClick={() => {
            if (!meetingTitle) {
              dispatch(setMenuVisible(false));
              dispatch(setUpdateMeetingTitleModalVisible(true));
              return;
            }
            dispatch(setMenuVisible(false));
            setIsImportFileChoiceVisible(true);
          }}
          menuRef={menuRef}
          leftPosition={menuPosition.left}
          isMenuVisible={isMenuVisible}
        />
        {/* Import image */}
        <MenuItem
          disabled={false}
          icon={imageIcon}
          label="Import image"
          onClick={() => {
            if (!meetingTitle) {
              dispatch(setMenuVisible(false));
              dispatch(setUpdateMeetingTitleModalVisible(true));
              return;
            }
            dispatch(setMenuVisible(false));
            setIsUploadImagesModalVisible(true);
          }}
          menuRef={menuRef}
          leftPosition={menuPosition.left}
          isMenuVisible={isMenuVisible}
        />
        {/* Import document */}
        <MenuItem
          disabled={false}
          icon={documentIcon}
          label="Import document"
          onClick={() => {
            if (!meetingTitle) {
              dispatch(setMenuVisible(false));
              dispatch(setUpdateMeetingTitleModalVisible(true));
              return;
            }
            dispatch(setMenuVisible(false));
            setIsUploadDocumentsModalVisible(true);
          }}
          menuRef={menuRef}
          leftPosition={menuPosition.left}
          isMenuVisible={isMenuVisible}
        />
      </ul>
    </div>,
    document.body
  );
}
